import React, { useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';

const BackgroundAudio = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasPlayed, setHasPlayed] = useState(false);

  useEffect(() => {
    // Check if audio has already been played in this session
    const audioPlayed = sessionStorage.getItem('audioPlayed');
    
    if (!audioPlayed && audioRef.current) {
      // Set volume to 65%
      audioRef.current.volume = 0.65;
      
      // Try to autoplay (may be blocked by browser)
      const playPromise = audioRef.current.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Autoplay started successfully
            setIsPlaying(true);
            setHasPlayed(true);
            sessionStorage.setItem('audioPlayed', 'true');
          })
          .catch((error) => {
            // Autoplay was prevented
            console.log('Autoplay prevented:', error);
            // User will need to click play button
          });
      }
    } else if (audioPlayed) {
      setHasPlayed(true);
    }
  }, []);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.volume = 0.65;
      audioRef.current.play();
      setIsPlaying(true);
      if (!hasPlayed) {
        setHasPlayed(true);
        sessionStorage.setItem('audioPlayed', 'true');
      }
    }
  };

  return (
    <>
      {/* Hidden audio element */}
      <audio
        ref={audioRef}
        src="https://customer-assets.emergentagent.com/job_notdienst-web-2/artifacts/4iimvc8y_Handwerkernotdienst.nrw%20audio.mp3"
        preload="auto"
        onEnded={() => setIsPlaying(false)}
      />
      
      {/* Fixed audio control button */}
      <button
        onClick={togglePlay}
        className="fixed bottom-24 right-6 z-40 bg-white hover:bg-gray-50 text-gray-700 rounded-full p-3 shadow-lg border-2 border-gray-200 transition-all duration-300 hover:scale-110"
        aria-label={isPlaying ? 'Audio pausieren' : 'Audio abspielen'}
        title={isPlaying ? 'Audio pausieren' : 'Audio abspielen'}
      >
        {isPlaying ? (
          <Volume2 className="w-5 h-5 text-[#0066cc]" />
        ) : (
          <VolumeX className="w-5 h-5 text-gray-500" />
        )}
      </button>
    </>
  );
};

export default BackgroundAudio;
